import { Vector4 } from "three";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import RectangleMesh from "../../instancing/Meshes/RectangleMesh";

export function getScoresRectMesh() {
  const conf = { rgbaCode: 1, posX: 1, posY: 1 };
  const colors = Array(7).fill(new Vector4(1, 0, 0, 1));
  const materialUniforms = getMaterialWithUniforms({ antialias: true })
    .setPaddingX([-0, 0, -0, 0])
    .setPaddingY([-1, -1, 1, 1])
    .setOffset([0, 0, 0, 0])
    .setColorMap(colors);

  return new RectangleMesh(materialUniforms, conf);
}

function getScoreColorInd(score) {
  if (score === null) {
    return 5;
  }
  if (score >= 9.88) {
    return 0;
  }
  if (score >= 7.52) {
    return 1;
  }
  if (score >= 3.71) {
    return 2;
  }
  if (score >= 1.16) {
    return 3;
  }
  return 4;
}

export function drawScores(scores, mesh) {
  const count = scores.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });

  for (let i = 0; i < count; i++) {
    const { region, phylopScore } = scores[i];
    const { g0, g1 } = region;
    const rgb = getScoreColorInd(phylopScore);
    setX(i, g0, g1, g0, g1);
    if (phylopScore > 0) {
      setY(i, phylopScore, phylopScore, 0, 0);
    } else {
      setY(i, 0, 0, phylopScore || 0, phylopScore || 0);
    }
    setRgb(i, rgb, rgb, rgb, rgb);
  }
}
